import { render } from "./Chip.vue?vue&type=template&id=47bb5a29&scoped=true"
import script from "./Chip.vue?vue&type=script&lang=js"
export * from "./Chip.vue?vue&type=script&lang=js"

import "./Chip.vue?vue&type=style&index=0&id=47bb5a29&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47bb5a29"]])

export default __exports__